module.exports = __webpack_public_path__ + "static/media/country_sh.d78f10ab.webp";